<template>
  <div class="animated fadeIn">
    <basic-heading title="New Customer" class="mb-3">
      <template #right-content>
        <b-button-toolbar key-nav aria-label="Key Customer Actions">
          <b-button variant="success" class="ml-1 text-white" to="/customer">
            <i class="fal fa-list" />
          </b-button>
        </b-button-toolbar>
      </template>
    </basic-heading>
    <permission-alert-gate
      :permissions="['add customer', 'add customer contact']"
    >
      <template #gated-content>
        <customer-form
          :is_customer_form="true"
          @updateFormData="updateFormData"
        />
        <customer-contact-form
          :is_customer_form="true"
          @updateFormData="updateFormData"
          form_label="Primary Contact"
        />
        <customer-location-form
          :is_customer_form="true"
          form_label="Primary Location"
          @updateFormData="updateFormData"
        />
        <b-row align-h="between" class="mb-4">
          <b-col cols="4">
            <b-button
              :disabled="!is_form_valid"
              @click="submit('addProject')"
              block
              variant="success"
              ><i class="fal fa-save" />
              {{ "Save & Open New Project" }}</b-button
            >
          </b-col>
          <b-col cols="2">
            <b-button
              :disabled="!is_form_valid"
              @click="submit"
              block
              variant="success"
              ><i class="fal fa-save" /> Save</b-button
            >
          </b-col>
        </b-row>
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import BasicHeading from "@/components/shared/BasicHeading";
import CustomerForm from "@/components/crm/customer/form/CustomerForm";
import CustomerContactForm from "@/components/crm/customercontact/form/CustomerContactForm";
import CustomerLocationForm from "@/components/crm/customerlocation/form/CustomerLocationForm";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { mapActions } from "vuex";
import { CrmRepositoryFactory } from "@/repositories/crm/CrmRepositoryFactory";

const CustomerRepository = CrmRepositoryFactory.get("customers");
const CustomerContactsRepository = CrmRepositoryFactory.get("customerContacts");
const CustomerLocationsRepository =
  CrmRepositoryFactory.get("customerLocations");

export default {
  name: "CustomerAdd",
  mixins: [ToastNotifications],
  components: {
    BasicHeading,
    CustomerContactForm,
    CustomerForm,
    CustomerLocationForm,
    PermissionAlertGate,
  },
  data() {
    return {
      form_data: {
        customer: null,
        customer_contact: null,
        customer_location: null,
      },
      is_valid: {
        customer: false,
        customer_contact: false,
        customer_location: false,
      },
    };
  },
  computed: {
    is_form_valid() {
      return Object.values(this.is_valid).reduce((acc, cur) => {
        return acc && cur;
      }, true);
    },
  },
  methods: {
    ...mapActions(["UPDATE_STEP_ONE"]),
    updateFormData(form, form_data, is_valid) {
      this.form_data[form] = { ...form_data };
      this.is_valid[form] = is_valid;
    },
    async submit(withProject) {
      try {
        const { data } = await CustomerRepository.create(
          this.form_data.customer
        );
        await CustomerContactsRepository.create({
          customer_id: data.id,
          ...this.form_data.customer_contact,
        });
        await CustomerLocationsRepository.create({
          customer_id: data.id,
          ...this.form_data.customer_location,
        });

        this.quickSuccessToast("Customer created", "You will be redirected...");

        if (withProject === "addProject") {
          this.UPDATE_STEP_ONE({
            name: "filter",
            value: data.short_name,
          });
          this.UPDATE_STEP_ONE({
            name: "customer_id",
            value: data.id,
          });

          this.$router.push("/projects/add");
        } else {
          this.$router.push(`/customer/${data.id}`);
        }
      } catch ({ response }) {
        const { status, data } = response;

        this.$bvToast.toast(`Code: ${status}. ${data.error}`, {
          title: "Server Error.",
          variant: "danger",
        });
      }
    },
  },
};
</script>
